<template>
  <div>
    <v-row>
      <v-col cols="12">
        <router-link :to="{ name: 'newReport' }">
          <v-btn color="primary">{{ $t('reports.new_report') }}</v-btn>
        </router-link>
      </v-col>
    </v-row>
    <v-row>
      <v-col cols="12">
        <data-table-with-pagination
          :headers="report_header"
          :dataList="report_list"
          :loading="load_table"
          :options="options"
          :itemLength="total_items"
        ></data-table-with-pagination>
      </v-col>
    </v-row>
  </div>
</template>

<script>
import { getData } from '@/api'
import DataTableWithPagination from '@/components/DataTableWithPagination.vue'
import { globalFunc } from '@/global'
export default {
  name: 'reports',
  components: {
    DataTableWithPagination,
  },
  mixins: [globalFunc],
  data: () => ({
    report_header: [],
    report_list: [],
    load_table: true,
    total_items: 0,
    current_page: 0,
    current_limit: 10,
    options: {},
  }),
  methods: {
    initializeHeader() {
      this.report_header = [
        {
          text: this.$t('reports.select_year'),
          value: 'select_year',
          width: '100px',
        },
        {
          text: this.$t('reports.publish_date'),
          value: 'publish_date',
          width: '115px',
        },
        {
          text: this.$t('reports.document_title'),
          value: 'document_title',
        },
        {
          text: this.$t('reports.upload_document'),
          value: 'upload_document',
          width: '150px',
        },
        { text: '', value: 'report_button', width: '200px' },
      ]
    },
    async initializeData() {
      try {
        this.load_table = true

        let params = new URLSearchParams()
        params.set('get_published_report', JSON.stringify({}))

        let report = await getData(params)

        let temp = []

        this.total_items = report.length

        for (let i = 0; i < report.length; i++) {
          let obj = report[i]
          temp.push({
            id: obj.id,
            select_year: obj.select_year,
            publish_date: obj.publish_date,
            document_title: obj.document_title.zh,
            upload_document: obj.document.zh,
          })
        }

        this.report_list = temp
        this.load_table = false
      } catch (error) {
        globalFunc.log(error)
        this.load_table = false
      }
    },
  },
  created() {
    this.initializeHeader()
    this.initializeData()
  },
}
</script>
